export const API_ROUTES = Object.freeze({
  LOGIN_WITH_EMAIL: '/auth/login/',
  LOGIN_WITH_EMAIL_TOKEN: '/auth/login-with-email-token/',
  STATIC: '/static/',
  ARTICLES: '/content/books/',
  feedback: '/feedback',
  SEND_FORGOT_PASSWORD: '/send_forgot_password/',
  PROFILE: '/user/profile/',
  COURSES: '/courses/',
  RESTORE_SUBSCRIPTION: '/restore_subscription',
});

export const INNER_API_ROUTES = Object.freeze({
  ARTICLES: '/api/articles',
  COURSES: '/api/courses',
  AFFIRMATION: '/api/affirmation',
  EDUCATION: '/api/education',
  LOGIN: '/api/auth/login',
  LOGOUT: '/api/auth/logout',
  RECOVERY: '/api/auth/recovery',
  PROFILE: '/api/profile',
  RESTORE_SUBSCRIPTION: '/api/restore-sub',
});

export const ASSISTANT_API_ROUTES = Object.freeze({
  SUGGESTIONS: '/suggestions',
  MESSAGES: '/messages',
  REACTIONS: '/messages/reactions',
  THREADS: '/threads',
});

export const ASSISTANT_PROXY_API_ROUTES = Object.freeze({
  SUGGESTIONS: '/api/ai-assistant/suggestions',
  MESSAGES: '/api/ai-assistant/messages',
  REACTION: '/api/ai-assistant/message-reaction',
  THREADS: '/api/ai-assistant/threads',
});
